/**
 * 노드 상세 링크 조립 (#207)
 * --------------------------------------------------------------------------
 * 링크를 만드는 곳이 **한 곳**이어야 합니다. 목록·breadcrumb·팔레트가 각자
 * 문자열을 붙이면 UID를 빼먹은 링크가 섞이고, 그 링크는 서버에서 400이 됩니다.
 *
 * 노드는 클러스터 스코프라 namespace 경로 아래가 아닙니다. 신원은 이름 + UID이고
 * UID는 쿼리로 실립니다 — 이름은 재사용되므로 경로만으로는 재생성된 노드와
 * 이전 노드를 구분할 수 없습니다.
 */

/**
 * nodeDetailPath는 노드 상세 경로입니다.
 *
 * 기존 검색 문자열(range·refresh 등 사용자 상태)을 **보존**합니다. 상세로 들어갈
 * 때 시간 범위가 초기화되면 사용자가 고른 상태를 화면 이동이 지우는 것입니다.
 * `uid`는 노드 신원이라 기존 값이 있어도 이 노드의 것으로 덮어씁니다.
 */
export function nodeDetailPath(name: string, uid: string, search: string): string {
  const params = new URLSearchParams(search);
  params.set("uid", uid);
  return `/nodes/${encodeURIComponent(name)}?${params.toString()}`;
}
